/* eslint-disable react/require-default-props */
import React from 'react';
import { Card } from './styles';

interface AiManagementStatCardProps {
  value: React.ReactNode;
  label: string;
  className?: string;
}

const AiManagementStatCard: React.FC<AiManagementStatCardProps> = ({
  value,
  label,
  className = '',
}) => (
  <Card className={`border text-center px-3 py-3 ${className}`}>
    <div className="stat-value font-weight-bold">{value}</div>
    <div className="stat-label text-muted">{label}</div>
  </Card>
);

export default AiManagementStatCard;
